import { useState, useEffect } from "react";
import { Menu, X, Home } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Navbar({ onNavigate, pages, currentPage }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (e, index) => {
    e.preventDefault();
    if (onNavigate) onNavigate(index);
    setMobileOpen(false);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/90 backdrop-blur-xl border-b border-gold-dim"
          : "bg-black/70 backdrop-blur-md"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16">
        <a
          href="#"
          onClick={(e) => handleNav(e, 0)}
          data-testid="navbar-logo"
          className="flex items-center gap-2.5 transition-all duration-300 hover:drop-shadow-[0_0_12px_rgba(201,168,76,0.5)]"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_site-creator-2145/artifacts/omqzty4u_15336.png"
            alt="Danny Davies"
            className="w-8 h-8 object-cover object-top rounded-full border border-[#c9a84c]/30"
          />
          <span className="font-heading text-xl font-semibold text-white tracking-tight">
            Chef <span className="text-gold">Compliance</span> UK
          </span>
        </a>

        <div className="hidden md:flex items-center gap-6">
          {(pages || []).map((page, i) => (
            <button
              key={page.id}
              onClick={(e) => handleNav(e, i)}
              data-testid={`nav-link-${page.label.toLowerCase()}`}
              className={`text-sm tracking-wide uppercase transition-all duration-200 hover:drop-shadow-[0_0_8px_rgba(201,168,76,0.5)] ${
                currentPage === i ? "text-gold" : "text-zinc-400 hover:text-gold"
              }`}
            >
              {page.label}
            </button>
          ))}
          <Button
            data-testid="nav-cta-button"
            onClick={(e) => handleNav(e, (pages || []).findIndex(p => p.id === "contact"))}
            className="bg-gold hover:bg-[#b8963f] text-black text-sm rounded font-semibold px-5 tracking-wide"
          >
            Get Started
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-gold"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 backdrop-blur-xl border-b border-gold-dim px-6 pb-6 animate-fade-in"
        >
          {(pages || []).map((page, i) => (
            <button
              key={page.id}
              onClick={(e) => handleNav(e, i)}
              className={`block w-full text-left py-3 text-sm transition-all border-b border-white/5 last:border-0 uppercase tracking-wide ${
                currentPage === i ? "text-gold" : "text-zinc-400 hover:text-gold"
              }`}
            >
              {page.label}
            </button>
          ))}
          <Button
            onClick={(e) => handleNav(e, (pages || []).findIndex(p => p.id === "contact"))}
            className="w-full mt-4 bg-gold hover:bg-[#b8963f] text-black text-sm rounded font-semibold"
          >
            Get Started
          </Button>
        </div>
      )}
    </header>
  );
}
